export const lineSeriesDropdownItems = [
    { id: 'closePrice' },
    { id: 'vwap' },
    { id: 'marketcap' },
    { id: 'numberOfShares' },
] as const

export const lineSeriesLabelKeys: Record<(typeof lineSeriesDropdownItems)[number]['id'], string> = {
    closePrice: 'pages.companies.graph.closePrice',
    vwap: 'pages.companies.graph.vwap',
    marketcap: 'pages.companies.marketCap',
    numberOfShares: 'pages.companies.numberOfShares',
}

export const graphLineSerieRoutingParam = 'lineSerie' as const

export const barSeriesDropdownItems = [
    { id: 'splitAdjustedQuantity' },
    { id: 'turnoverSek' },
    { id: 'tradedProportion' },
] as const

export const barSeriesLabelKeys: Record<(typeof barSeriesDropdownItems)[number]['id'], string> = {
    splitAdjustedQuantity: 'pages.companies.numberOfShares',
    turnoverSek: 'pages.companies.graph.turnoverSek',
    tradedProportion: 'pages.companies.graph.tradedProportion',
}

export const graphBarSerieRoutingParam = 'barSerie' as const
